import { PaymentOption } from '../utils/checkoutState';

const initialPaymentMethods: PaymentOption[] = [
  {
    paymentOptionKey: 'ratepay_invoice',
    paymentOptionProvider: 'ratepay',
    configuration: {
      deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
      fee: 0
    },
    isDisabled: false
  },
  {
    paymentOptionKey: 'ratepay_directdebit',
    paymentOptionProvider: 'ratepay',
    configuration: {
      deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
      fee: 0
    },
    isDisabled: true,
    notifications: [{ id: '43092', type: 'error', textTranslationKey: 'payment.notifications.constraintMinOrderValue' }]
  },
  {
    paymentOptionKey: 'paypal_instant',
    paymentOptionProvider: 'paypal',
    configuration: {
      deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
      fee: 0
    },
    isDisabled: false
  },
  // {
  //   paymentOptionKey: 'afterpay_invoice',
  //   paymentOptionProvider: 'afterpay',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: false,
  // },
  {
    paymentOptionKey: 'adyen_creditcard',
    paymentOptionProvider: 'adyen',
    configuration: {
      deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
      fee: 0
    },
    isDisabled: false
  },
  // {
  //   paymentOptionKey: 'standard_cod',
  //   paymentOptionProvider: 'aboutyou',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     codPaymentFee: 199,
  //     fee: 0,

  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'computop_creditcard',
  //   paymentOptionProvider: 'computop',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'computop_maestro',
  //   paymentOptionProvider: 'computop',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'computop_bancontact',
  //   paymentOptionProvider: 'computop',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: true,
  // },
  // {
  //   paymentOptionKey: 'computop_payu',
  //   paymentOptionProvider: 'computop',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: true,
  // },
  // {
  //   paymentOptionKey: 'computop_paydirekt',
  //   paymentOptionProvider: 'computop',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: true,
  // },
  // {
  //   paymentOptionKey: 'computop_postfinance',
  //   paymentOptionProvider: 'computop',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: true,
  // },
  // {
  //   paymentOptionKey: 'klarna_paylater',
  //   paymentOptionProvider: 'klarna',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'klarna_paynow_direct_debit',
  //   paymentOptionProvider: 'klarna',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: false,
  // },
  {
    paymentOptionKey: 'klarna_paynow_direct_bank_transfer',
    paymentOptionProvider: 'klarna',
    configuration: {
      deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
      fee: 0,
      instalments: []
    },
    isDisabled: false
  },
  {
    paymentOptionKey: 'witt_pay_instalments',
    paymentOptionProvider: 'aboutyou',
    configuration: {
      deferral: { weeks: 6, isSupported: true, isSelected: false, autoApplyDeferral: false },
      instalments: [
        { number: 3, isSelected: true },
        { number: 6, isSelected: false }
      ],
      fee: 1000,
      isRecurring: false
    },
    isDisabled: false
  }
  // {
  //   paymentOptionKey: 'arvato_creditcard',
  //   paymentOptionProvider: 'arvato',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,

  //
  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'arvato_paypal',
  //   paymentOptionProvider: 'arvato',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,

  //
  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'arvato_ideal',
  //   paymentOptionProvider: 'arvato',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,

  //
  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'amazon_pay',
  //   paymentOptionProvider: 'amazon_pay',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,

  //
  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'adyen_ideal',
  //   paymentOptionProvider: 'adyen',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,

  //
  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'adyen_mobilepay',
  //   paymentOptionProvider: 'adyen',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,

  //
  //   },
  //   isDisabled: false,
  // },
  // {
  //   paymentOptionKey: 'adyen_mbway',
  //   paymentOptionProvider: 'adyen',
  //   configuration: {
  //     deferral: { weeks: 0, isSupported: false, isSelected: false, autoApplyDeferral: false },
  //     fee: 0,
  //   },
  //   isDisabled: false,
  // },
];

export default initialPaymentMethods;
